/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  useParams,
  Navigate,
} from "react-router-dom";
import { useEffect, useState, useRef, useMemo } from "react";
import toast, { Toaster } from "react-hot-toast";

import Login from "./pages/Login/login";
import LoginSaudi from "./pages/LoginSaudi/login-saudi";
// import Dashboard from "./pages/Dashboard/dashboard";
import OrderManagement from "./pages/OrderManagement/order-management";
import ViewOrderDetails from "./pages/OrderManagement/ViewOrderDetails";
import ViewStaffDetails from "./pages/Users/ViewStaffDetails";
import ViewMerchantDetails from "./pages/Users/ViewMerchantDetails";
import ViewDriverDetails from "./pages/Users/ViewDriverDetails";
import Location from "./pages/Location/location";
import Users from "./pages/Users/users";
import Integration from "./pages/Integration/integration";
import Notification from "./pages/Notification/notification";
import Header from "./components/Header";
import ForgotPassword from "./pages/Forgot-password/ForgotPassword";
import ForgotPasswordSaudi from "./pages/Forgot-password-saudi/ForgotPasswordSaudi";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import ChangePasswordSaudi from "./pages/ChangePasswordSaudi/ChangePasswordSaudi";
import Odometer from "./pages/Odometer/odometer";
import Fuel from "./pages/Fuel/fuel";
import ShelveManagement from "./pages/ShelveManagement/inventory-shelve";
import WeightManagement from "./pages/WeightManagement/weight-management";
import LineHaulManagement from "./pages/LineHaulManagement/line-haul-management";
import Settings from "./pages/Settings/settings";
import CreateWarehouse from "./pages/CreateWarehouse/create-warehouse";
import LoadingScreen from "./components/common/LoadingScreen";
import Profile from "./pages/Profile/profile";
import Warehouse from "./pages/Warehouse/warehouse";
import ViewOutSourceDetails from "./pages/Users/ViewOutSourceDetails";
import ViewCustomerDetails from "./pages/Users/ViewCustomerDetails";
import ViewDistrictDetails from "./pages/Warehouse/ViewDistrictDetails";
import ViewCoverageCitiesDetails from "./pages/Warehouse/ViewCoverageCitiesDetails";
import DRSManagement from "./pages/DRSManagement/drs-management";
import RouteManagement from "./pages/RouteManagement/route-management";
import ShipmentList from "./pages/DRSManagement/ShipmentList";
import ShippingConfiguration from "./pages/ShippingConfiguration/shipping-configuration";
import FleetManagement from "./pages/FleetManagement/fleet-management";
import ViewVehicleDetails from "./pages/FleetManagement/ViewVehicleDetails";
import RouteAssign from "./pages/RouteManagement/RouteAssign";
import PickupManagement from "./pages/PickupManagement/pickup-management";
import InvoiceManagement from "./pages/InvoiceManagement/invoice-management";
import ManifestManagement from "./pages/ManifestManagement/manifest-management";
import ManifestDetails from "./pages/ManifestManagement/ManifestDetails";
import ZoneManagement from "./pages/ZoneManagement/zone-management";
import OutletManagement from "./pages/OutletManagement/outlet-management";
import HelpandSupport from "./pages/HelpandSupport/help-and-support";
import PendingOrders from "./pages/Integration/PendingOrders";
import ActivityLogs from "./pages/ActivityLogs/activity-logs";
import AddRoute from "./pages/RouteManagement/AddRoute";
import Forward from "./pages/Forward/forward";
import Subscription from "./pages/Subscription/subscription";
import AddItem from "./pages/ShelveManagement/add-item";
import InverntoryProduct from "./pages/ShelveManagement/inverntory-product";
import InventoryMangement from "./pages/ShelveManagement/inventory-mangement";
import CreatedOrders from "./pages/CreatedOrders";
import PickListPage from "./pages/PickList";
import DocumentDesigner from "./pages/DocumentDesigner";

import CompanyPage from "./pages/CompanyPage";
import HRPage from "./pages/HRPage";
import EmployeeDetails from "./pages/HR/Employee/EmployeeDetails";
import PayrollPage from "./pages/PayrollPage";
import RecruitmentPage from "./pages/RecruitmentPage";
import LetterPage from "./pages/LetterPage";
import AssetPage from "./pages/AssetPage";
import PerformancePage from "./pages/PerformancePage";
import NoticeboardPage from "./pages/NoticeboardPage";
import HRSetting from "./pages/HR/HRSetting/HRSetting";

import { useProfileData } from "./apis/profileApis";
import { initSocket } from "./socket";
import { useQueryClient } from "@tanstack/react-query";
import FillInformation from "./pages/FillInformation/fill-info";
import { useDispatch, useSelector } from "react-redux";
import { useIdleTimeout } from "./hooks/useIdleTimeout";
import {
  addNewOrder,
  addSingleStatusUpdate,
} from "./features/orderStatusHistories/ordersStatusHistoriesSlice";
import { pickupStatusUpdate } from "./features/pickup/pickupSlice";
import { linehaulStatusUpdate } from "./features/linehaul/linehaulSlice";
import HowInstall from "./pages/Integration/HowInstall";
import FillInstallationDetails from "./pages/Integration/_components/FillInstallationDetails";
import EditModal from "./pages/Integration/_components/EditModal";
import LinehaulViewDetails from "./pages/ManifestManagement/LinehaulViewDetails";
import ShippingManifiestViewDetail from "./pages/ManifestManagement/ShippingManifiestViewDetail";
import { returnToShipperStatusUpdate } from "./features/returnToShipper/returnToShipperSlice";
import { staffUpdate, addStaff } from "./features/staff/staffSlice";
import { addDriver, driverUpdate } from "./features/driver/driverSlice";
import {
  addOutSource,
  outSourceUpdate,
} from "./features/outSource/outSourceSlice";
import { addClient, clientUpdate } from "./features/client/clientSlice";
import {
  setSocketConnected as setDriverMapSocketConnected,
  updateDriverLocation,
  updateMultipleDrivers,
  setDriverOnlineStatus,
  setDrivers,
  MapDriver,
} from "./features/driverMap/driverMapSlice";
import ReturnToShiperViewDetails from "./pages/ManifestManagement/ReturnToShiperViewDetails";
import NotificationView from "./pages/Notification/notificationView";
import { addProduct } from "./features/product/productSlice";
import ShopifyPendingOrders from "./pages/Integration/ShopifyPendingOrders";
import Payment from "./pages/Subscription/payment";
import FloatingChatButton from "./components/FloatingChatButton";
import SearchResults from "./pages/SearchResults/searchResults";
import CredentialsModal from "./pages/Integration/_components/CredentialsModal";
import ViewDarkStoreDetails from "./pages/DarkStore/ViewDarkStoreDetails";
import {
  addDarkStore,
  darkStoreUpdate,
} from "./features/darkStores/darkStoresSlice";
import DarkStoreManagement from "./pages/DarkStore/DarkStore";
import ProductItemsMovement from "./pages/ShelveManagement/_components/ProductMovement";
import Packaging from "./pages/Packaging";
import Dispatched from "./pages/Dispatched";
import CreateOrder from "./pages/CreateOrder";
import GlobalTooltipPortal from "./components/common/TooltipPortal";

function KeyedEditModal() {
  const { id, insalledId } = useParams<{ id: string; insalledId: string }>();
  return <EditModal key={`${id}-${insalledId}`} />;
}

const playNotificationSound = () => {
  try {
    const audio = new Audio(
      "https://actions.google.com/sounds/v1/alarms/beep_short.ogg",
    );
    audio.play().catch((e) => console.log("Audio play failed:", e));
  } catch (err) {}
};

const showNativeNotification = (
  title: string,
  options?: NotificationOptions,
  onClick?: () => void,
) => {
  if (!("Notification" in window)) return;

  const createNotification = () => {
    const n = new window.Notification(title, options);
    if (onClick) {
      n.onclick = (e) => {
        e.preventDefault();
        window.focus();
        onClick();
        n.close();
      };
    }
    playNotificationSound();
  };

  if (window.Notification.permission === "granted") {
    createNotification();
  } else if (window.Notification.permission !== "denied") {
    window.Notification.requestPermission().then((permission: string) => {
      if (permission === "granted") {
        createNotification();
      }
    });
  }
};

function AppContent() {
  const profile = useSelector((state: any) => state.auth.profile);
  const permissions = useSelector((state: any) => state.auth.permissions);
  const socketRef = useRef<any>(null);
  const [socketConnected, setSocketConnected] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isSuccess, refetch: fetchProfile } = useProfileData();
  const queryClient = useQueryClient();

  const LoginComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true" ? LoginSaudi : Login;
  const ForgotComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? ForgotPasswordSaudi
      : ForgotPassword;
  const ChangePasswordComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? ChangePasswordSaudi
      : ChangePassword;

  const isExternalAdmin = process.env.REACT_APP_EXTERNAL_ADMIN === "true";

  useEffect(() => {
    // Update title
    document.title = isExternalAdmin ? "Najiz Express" : "tracktechs";

    // Update favicon
    let link = document.querySelector(
      "link[rel*='icon']",
    ) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      document.head.appendChild(link);
    }
    link.rel = "icon";
    link.href = isExternalAdmin ? "/logo/najizFavicon.png" : "/favicon.ico";
  }, [isExternalAdmin]);
  // 1 minute inactivity timeout for testing
  useIdleTimeout(30 * 60 * 1000);

  const hasHRMSAccess = useMemo(() => {
    const isSuperAdmin = profile?.type === "superAdmin" || profile?.role === "superAdmin";
    if (isSuperAdmin) return true;

    // For clients and client staff, HR access is strictly determined by hrOption === "HRMS"
    const isClientOrStaff = profile?.type === "client" || profile?.type === "lmStaff";
    if (isClientOrStaff) {
      return profile?.hrOption === "HRMS";
    }

    return (
      profile?.hrOption === "HRMS" ||
      profile?.clientType === "HRMS" ||
      permissions?.some((p: any) => 
        ["HRMS", "HR", "Payroll", "Recruitment", "Company", "Letter", "Asset", "Performance", "Noticeboard"].includes(p?.module) ||
        p?.module?.toLowerCase()?.includes("hr")
      )
    );
  }, [profile, permissions]);

  const allHideHeaderRoutes = [
    "/",
    "/forgot-password",
    "/password-changed",
    "/create-warehouse",
    "/fill-info",
  ];
  const hideHeader = allHideHeaderRoutes.includes(location.pathname);

  const user = data;

  useEffect(() => {
    if (isSuccess) {
      const isAuthenticated = data && data !== "Invalid or expired token";

      if (
        !isAuthenticated &&
        !allHideHeaderRoutes.includes(location.pathname)
      ) {
        navigate("/");
      } else if (
        isAuthenticated &&
        !data?.isWarehouseCreated &&
        !data?.warehouses?.length &&
        data?.clientType !== "DS"
      ) {
        navigate("/create-warehouse");
      } else if (isAuthenticated && location.pathname === "/") {
        navigate("/orders");
      } else if (
        !isAuthenticated &&
        allHideHeaderRoutes.includes(location.pathname)
      ) {
        if (location.pathname === "/fill-info") {
          navigate(`${location.pathname}${location.search}`);
        }
      }
    }
  }, [data, isSuccess, location.pathname, navigate]);

  // Socket setup (single instance)
  useEffect(() => {
    if (
      process.env.REACT_APP_Socket === "true" &&
      user?.id &&
      !socketRef.current
    ) {
      socketRef.current = initSocket();
      const socket = socketRef.current;

      console.log("🔌 Initializing socket:", socket);

      socket.on("connect", () => {
        console.log("✅ Socket Connected!", socket.id);
        setSocketConnected(true);
        socket.emit("setup", { id: user.id });
        dispatch(setDriverMapSocketConnected(true));
      });

      socket.on("disconnect", () => {
        console.log("❌ Socket Disconnected!");
        setSocketConnected(false);

        dispatch(setDriverMapSocketConnected(false));
      });

      socket.on("location received", (data: any) => {
        console.log("📍 Location received:", data);
      });

      socket.on("notification Received", (data: any) => {
        console.log("🔔 Notification received:", data);
        fetchProfile();
      });

      socket.on("new-order-status", (data: any) => {
        console.log("🔔 new-order-status:", data);
        dispatch(addSingleStatusUpdate(data));
        // toast.success(`New Status Of Order ${data?.awbNumber}`);
      });

      socket.on("chat-notification", (data: any) => {
        console.log("🔔 Chat notification received:", data);
        const senderName = data.senderName || "Someone";
        toast.success(`New message from ${senderName}`);
        showNativeNotification(
          `Message from ${senderName}`,
          { body: data.message },
          () => {
            if (data.roomId)
              window.location.href = `/help-and-support?chatId=${data.roomId}`;
          },
        );
        // Trigger profile/notifications refresh
        fetchProfile();
      });

      socket.on("ticket-notification", (data: any) => {
        console.log("🔔 Ticket notification received:", data);
        toast.success(`${data.type}: ${data.message}`);
        showNativeNotification(
          `Ticket ${data.type}`,
          { body: data.message },
          () => {
            if (data.ticketId)
              window.location.href = `/help-and-support?ticketId=${data.ticketId}`;
          },
        );
        fetchProfile();
      });

      socket.on("new-chat-message", (data: any) => {
        console.log("🔔 New chat message received:", data);
        if (data?.senderId !== user?.id) {
          const sender = data?.senderType || "Someone";
          showNativeNotification(
            "New Message",
            { body: `New message from ${sender}` },
            () => {
              if (data.roomId)
                window.location.href = `/help-and-support?chatId=${data.roomId}`;
            },
          );
        }
      });

      socket.on("new-order", (data: any) => {
        console.log("🔔 new-order:", data);
        dispatch(addNewOrder(data));
      });

      // socket.on("product", (data: any) => {
      //   console.log("🔔 product:", data);
      //   dispatch(addProduct(data));
      //   toast.success(`Product ${data?.category}`);
      // });

      socket.on("pickup-assign-driver", (data: any) => {
        console.log("🔔 pickup-assign-driver:", data);
        dispatch(pickupStatusUpdate(data));
        // toast.success(`New Status Of pickup ${data?.pickupId}`);
      });

      socket.on("linehaul-status-update", (data: any) => {
        console.log("🔔 linehaul-status-update:", data);
        dispatch(linehaulStatusUpdate(data));
        // toast.success(`New Status Of linehaul ${data?.customId}`);
      });

      socket.on("return-to-shipper-status-update", (data: any) => {
        console.log("🔔 return-to-shipper-status-update:", data);
        dispatch(returnToShipperStatusUpdate(data));
        // toast.success(`New Status Of return to shipper ${data?.returnId}`);
      });

      socket.on("new-staff", (data: any) => {
        console.log("🔔 new-staff:", data);
        dispatch(addStaff(data));
        // toast.success(`Staff update of ${data?.fullName}`);
      });

      socket.on("staff-update", (data: any) => {
        console.log("🔔 staff-update:", data);
        dispatch(staffUpdate(data));
        // toast.success(`Staff update of ${data?.fullName}`);
      });

      socket.on("new-driver", (data: any) => {
        console.log("🔔 new-driver:", data);
        dispatch(addDriver(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      socket.on("new-dark-store", (data: any) => {
        console.log("🔔 new-dark-store:", data);
        dispatch(addDarkStore(data));
      });

      socket.on("driver-update", (data: any) => {
        console.log("🔔 driver-update:", data);
        dispatch(driverUpdate(data));
        // toast.success(`Driver update of ${data?.name}`);
      });

      socket.on("dark-store-update", (data: any) => {
        console.log("🔔 dark-store-update:", data);
        dispatch(darkStoreUpdate(data));
      });

      socket.on("out-source-update", (data: any) => {
        console.log("🔔 out-source-update:", data);
        dispatch(outSourceUpdate(data));
        // toast.success(`Out Source update of ${data?.companyName}`);
      });

      socket.on("new-outsource", (data: any) => {
        console.log("🔔 new-outsource:", data);
        dispatch(addOutSource(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      socket.on("client-update", (data: any) => {
        console.log("🔔 client-update:", data);
        dispatch(clientUpdate(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      socket.on("new-client", (data: any) => {
        console.log("🔔 new-client:", data);
        dispatch(addClient(data));
        // toast.success(`Client update of ${data?.contactPerson}`);
      });

      // ==================== Driver Map Socket Events ====================

      // Single driver location update
      socket.on(
        "driver-location-update",
        (data: any) => {
          console.log("Driver location update:", data);
          const driverId = data.id || data.driverId;
          if (!driverId) return;

          const normalizedData = {
            ...data,
            id: String(driverId),
          };

          // Parse coordinates if they come as strings
          if (normalizedData.latitude && normalizedData.longitude) {
            const lat = parseFloat(normalizedData.latitude as string);
            const lon = parseFloat(normalizedData.longitude as string);

            if (!isNaN(lat) && !isNaN(lon)) {
              dispatch(
                updateDriverLocation({
                  ...normalizedData,
                  lat,
                  lon,
                  latitude: String(lat),
                  longitude: String(lon),
                }),
              );
            }
          } else {
            dispatch(updateDriverLocation(normalizedData));
            console.log("Driver location update without lat/lon:", normalizedData);
          }
        },
      );

      socket.on("drivers-batch-update", (data: any[]) => {
        // console.log("Batch driver update:", data.length, "drivers");

        const transformedDrivers = data.map((driver) => {
          const driverId = driver.id || driver.driverId;
          const normalizedDriver = {
            ...driver,
            id: driverId ? String(driverId) : undefined,
          };
          if (normalizedDriver.latitude && normalizedDriver.longitude) {
            const lat = parseFloat(normalizedDriver.latitude as string);
            const lon = parseFloat(normalizedDriver.longitude as string);

            if (!isNaN(lat) && !isNaN(lon)) {
              return {
                ...normalizedDriver,
                lat,
                lon,
                latitude: String(lat),
                longitude: String(lon),
              };
            }
          }
          return normalizedDriver;
        }).filter(d => d.id !== undefined);

        dispatch(updateMultipleDrivers(transformedDrivers));
      });

      // Initial driver data load from socket
      socket.on("initial-driver-data", (data: any[]) => {
        // console.log(
        //   "Initial driver data from socket:",
        //   data.length,
        //   "drivers"
        // );

        const transformedDrivers: MapDriver[] = data
          .map((driver: any) => {
            const lat = parseFloat(driver.latitude || driver.lat);
            const lon = parseFloat(driver.longitude || driver.lon);

            if (isNaN(lat) || isNaN(lon)) {
              console.warn("Invalid coordinates for driver:", driver);
              return null;
            }

            return {
              ...driver,
              id: driver?.id || String(Math.random()),
              name: driver?.name || "Unknown Driver",
              code: driver?.code || "",
              phone: driver?.phone || "",
              email: driver?.email || "",
              vehicle: driver?.vehicle || "Unknown",
              vehicleNumber: driver?.vehicleNumber || "",
              image:
                driver?.image ||
                "https://randomuser.me/api/portraits/men/32.jpg",
              latitude: String(lat),
              longitude: String(lon),
              lat,
              lon,
              speed: driver?.speed || 0,
              direction: driver?.direction || 0,
              accuracy: driver?.accuracy,
              heading: driver?.direction || 0,
              online: driver?.online !== undefined ? driver?.online : true,
              currentLocation:
                driver?.currentLocation ||
                `Lat: ${lat.toFixed(4)}, Lon: ${lon.toFixed(4)}`,
              ordersToday: driver?.ordersToday || 0,
              ordersCompleted: driver?.ordersCompleted || 0,
              rating: driver?.rating || 4.5,
            } as MapDriver;
          })
          .filter((driver): driver is MapDriver => driver !== null);

        dispatch(setDrivers(transformedDrivers));
      });

      socket.on(
        "driver-status-change",
        (data: { id: string; online: boolean }) => {
          console.log("🔄 Driver status changed:", data);
          dispatch(setDriverOnlineStatus(data));
        },
      );

      socket.on("backend-change", (data: { model: string; action: string }) => {
        console.log("🔄 Backend change received:", data);

        // 1. Only track UI-relevant models
        const trackedModels = [
          "Order", "OrderStatusHistory", "Driver", "Staff", "StaffDetails",
          "ClientDetails", "LmClient", "DarkStore", "PickupRequest",
          "LineHaulRequest", "Vehicle", "Warehouse", "AdminNotifications",
          "ChatMessage", "ChatRoom", "PickList", "ProductManifest",
          "LinehaulManifest", "ShippingPartnerManifest", "ReturnToShipper",
          "DRS", "OutForDeliveryOrder", "DRSSwap",
          "Inventory", "InventoryMovement", "ProductItem", "ProductVariant",
          "WhAreas", "WhRows", "WhRacks", "WhLevels", "WhBins", "WhFloors", "WhPallets",
          "ProductMovement", "OrderAllocation", "Outlet",
          "Channel", "ChannelConnection", "ChannelCredential", "ChannelStatus",
          "Route", "ZoneManagement", "Tire", "DarkStoreRadius", "DarkStoreRadiusPricing",
          "LmNotifications", "ShipmentMessageTemplate"
        ];
        if (!trackedModels.includes(data.model)) {
          return;
        }

        // 2. Prevent invalidations if the user is typing or if any active edit/add form is open
        const activeElement = document.activeElement;
        const isTyping = activeElement && ["INPUT", "TEXTAREA", "SELECT"].includes(activeElement.tagName);
        
        const hasActiveForm = Array.from(document.querySelectorAll("input, textarea, select")).some(el => {
          const tagName = el.tagName;
          const type = el.getAttribute("type");
          const placeholder = el.getAttribute("placeholder")?.toLowerCase() || "";
          const id = el.id?.toLowerCase() || "";
          const name = el.getAttribute("name")?.toLowerCase() || "";
          const className = el.className?.toLowerCase() || "";

          // Ignore checkboxes, radio buttons, hidden inputs, files, buttons
          const isIgnoredInput = type && ["checkbox", "radio", "hidden", "file", "button", "submit", "reset"].includes(type);
          if (isIgnoredInput) return false;

          // Ignore search fields
          const isSearch = type === "search" || 
                           placeholder.includes("search") || 
                           id.includes("search") || 
                           name.includes("search") || 
                           className.includes("search");
          if (isSearch) return false;

          // Ignore pagination selects / limit selectors
          const isPagination = tagName === "SELECT" && (
            name.includes("limit") || 
            name.includes("page") || 
            name.includes("size") || 
            id.includes("limit") || 
            id.includes("page") || 
            id.includes("size") || 
            className.includes("limit") || 
            className.includes("page") || 
            className.includes("size")
          );
          if (isPagination) return false;

          // Ignore filter & sort selectors
          const isFilterOrSort = name.includes("filter") || 
                                 name.includes("sort") || 
                                 id.includes("filter") || 
                                 id.includes("sort") || 
                                 className.includes("filter") || 
                                 className.includes("sort") || 
                                 placeholder.includes("filter") || 
                                 placeholder.includes("sort");
          if (isFilterOrSort) return false;

          // Ignore disabled / readonly
          const isDisabled = el.hasAttribute("disabled") || el.hasAttribute("readonly");
          if (isDisabled) return false;

          // Check if it is inside a form or a modal/sidebar/drawer/popup/overlay container
          let parent = el.parentElement;
          let insideFormOrModal = false;
          while (parent) {
            const pTagName = parent.tagName;
            const pRole = parent.getAttribute("role") || "";
            const pId = parent.id || "";
            const pClassName = typeof parent.className === "string" ? parent.className : "";

            if (pTagName === "FORM" || pTagName === "DIALOG") {
              insideFormOrModal = true;
              break;
            }
            if (pRole === "dialog" || pRole === "alertdialog") {
              insideFormOrModal = true;
              break;
            }
            const lowerId = pId.toLowerCase();
            const lowerClass = pClassName.toLowerCase();
            if (
              lowerId.includes("modal") || lowerId.includes("dialog") || lowerId.includes("drawer") || lowerId.includes("sidebar") || lowerId.includes("popup") ||
              lowerClass.includes("modal") || lowerClass.includes("dialog") || lowerClass.includes("drawer") || lowerClass.includes("sidebar") || lowerClass.includes("popup") ||
              (lowerClass.includes("fixed") && lowerClass.includes("z-"))
            ) {
              insideFormOrModal = true;
              break;
            }
            parent = parent.parentElement;
          }

          if (!insideFormOrModal) return false;

          // If we reach here, it's an active text/number/email/select/textarea form field inside a form/modal
          return true;
        });

        const isEditingPath = /[\/(]edit|install|connect|add|create|fill-info/i.test(window.location.pathname);
        if (isTyping || hasActiveForm || isEditingPath) {
          console.log("⏳ Active form or typing detected. Skipping real-time refresh to protect user inputs.");
          return;
        }

        // 3. Only refresh if the current page/path is relevant to the model
        const path = window.location.pathname;
        const modelToPaths: Record<string, RegExp[]> = {
          Order: [/^\/orders/, /^\/dashboard/, /^\/packaging/, /^\/dispatched/, /^\/created-orders/, /^\/pending-order/, /^\/pickup-management/, /^\/line-haul-management/, /^\/manifest/, /^\/drs-management/, /^\/shipment-list/],
          OrderStatusHistory: [/^\/orders/, /^\/dashboard/, /^\/packaging/, /^\/dispatched/, /^\/created-orders/, /^\/pending-order/, /^\/pickup-management/, /^\/line-haul-management/, /^\/manifest/, /^\/drs-management/, /^\/shipment-list/],
          PickList: [/^\/orders/, /^\/pick-list/, /^\/dashboard/],
          Driver: [/^\/users/, /^\/driver/, /^\/location/, /^\/fleet-management/],
          Staff: [/^\/users/, /^\/staff/],
          StaffDetails: [/^\/users/, /^\/staff/],
          ClientDetails: [/^\/users/, /^\/view-merchant-details/],
          LmClient: [/^\/users/, /^\/view-merchant-details/],
          DarkStore: [/^\/dark-store/, /^\/settings/],
          PickupRequest: [/^\/pickup-management/, /^\/dashboard/, /^\/manifest/],
          LineHaulRequest: [/^\/line-haul-management/, /^\/manifest/, /^\/dashboard/],
          Vehicle: [/^\/fleet-management/, /^\/view-vehicle-details/, /^\/users/, /^\/driver/, /^\/dashboard/],
          Warehouse: [/^\/warehouse/],
          AdminNotifications: [/.*/],
          ChatMessage: [/^\/help-and-support/],
          ChatRoom: [/^\/help-and-support/],
          ProductManifest: [/^\/manifest/, /^\/dashboard/],
          LinehaulManifest: [/^\/manifest/, /^\/pickup-management/, /^\/line-haul-management/, /^\/dashboard/],
          ShippingPartnerManifest: [/^\/manifest/, /^\/dashboard/],
          ReturnToShipper: [/^\/manifest/, /^\/dashboard/],
          DRS: [/^\/drs-management/, /^\/shipment-list/, /^\/dashboard/, /^\/manifest/],
          OutForDeliveryOrder: [/^\/drs-management/, /^\/shipment-list/, /^\/dashboard/, /^\/manifest/],
          DRSSwap: [/^\/drs-management/, /^\/shipment-list/, /^\/dashboard/, /^\/manifest/],
          Inventory: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          InventoryMovement: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          ProductItem: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          ProductVariant: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          WhAreas: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          WhRows: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          WhRacks: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          WhLevels: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          WhBins: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          WhFloors: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          WhPallets: [/^\/inventory-management/, /^\/inventory-product/, /^\/inventory-shelve/, /^\/dashboard/],
          ProductMovement: [/^\/reports/, /^\/dashboard/],
          OrderAllocation: [/^\/reports/, /^\/dashboard/],
          Outlet: [/^\/outlet-management/, /^\/dashboard/],
          Channel: [/^\/integration/, /^\/dashboard/],
          ChannelConnection: [/^\/integration/, /^\/dashboard/],
          ChannelCredential: [/^\/integration/, /^\/dashboard/],
          ChannelStatus: [/^\/integration/, /^\/dashboard/],
          Route: [/^\/settings/, /^\/route-management/],
          ZoneManagement: [/^\/settings/, /^\/zone-management/],
          Tire: [/^\/settings/],
          DarkStoreRadius: [/^\/settings/],
          DarkStoreRadiusPricing: [/^\/settings/],
          LmNotifications: [/^\/settings/],
          ShipmentMessageTemplate: [/^\/settings/],
        };

        const paths = modelToPaths[data.model];
        const isPathRelevant = paths && paths.some(regex => regex.test(path));
        if (!isPathRelevant) {
          console.log(`\u23ed\ufe0f Change in ${data.model} is not relevant to ${path}. Skipping.`);
          return;
        }

        // 4. Invalidate the query keys
        const modelToQueryKey: Record<string, string[]> = {
          Order: [
            "orders", "order-details", "order", "orderOperations", "ordersData", 
            "routeOrdersData", "OrderDetails", "OrderDetailsStatusHistory", 
            "deleteOrdersData", "orderShipmentsData", "shipmentsViewData", "orderLineItemsStock",
            "packagingData", "todayPackedStream", "packagingStaff", "picklists", "picklist",
            "unifiedManifest", "DRSData", "DRSDetails", "CodOrdersTransactionsData", "swapData", "swapDetails",
            "pickupLocationData", "linehaulShipments", "pickupShipments", "returnToShipper", "shipping-partner-manifest-details", "itemProductViewData"
          ],
          OrderStatusHistory: [
            "orders", "order-details", "order", "orderOperations", "ordersData", 
            "routeOrdersData", "OrderDetails", "OrderDetailsStatusHistory", 
            "deleteOrdersData", "orderShipmentsData", "shipmentsViewData", "orderLineItemsStock",
            "packagingData", "todayPackedStream", "packagingStaff", "picklists", "picklist",
            "unifiedManifest", "DRSData", "DRSDetails", "CodOrdersTransactionsData", "swapData", "swapDetails",
            "pickupLocationData", "linehaulShipments", "pickupShipments", "returnToShipper", "shipping-partner-manifest-details", "itemProductViewData"
          ],
          PickList: [
            "picklists", "picklist", "orders", "order-details", "order", "ordersData",
            "OrderDetails", "OrderDetailsStatusHistory"
          ],
          Driver: ["drivers", "driver-details", "driver", "admin-drivers"],
          Staff: ["staffs", "staff-details", "staff", "admin-staff"],
          StaffDetails: ["staffs", "staff-details", "staff", "admin-staff"],
          ClientDetails: ["clients", "client-details", "client"],
          LmClient: ["clients", "client-details", "client"],
          DarkStore: ["dark-stores", "darkStores", "dark-store", "darkStoreRadiusData", "radiusAllData", "darkStoreAllData", "darkStoreDetailsData", "clientDarkStores", "darkStoreBranches"],
          PickupRequest: ["pickups", "pickup-details", "pickup", "unifiedManifest", "pickupLocationData", "pickupShipments"],
          LineHaulRequest: ["linehaul", "linehauls", "line-haul", "unifiedManifest"],
          Vehicle: [
            "vehicles", "vehicle-details", "vehicle", "VehicleList", 
            "fleetCardsSummary", "vehiclesData", "vehicleAllData", "assignVehicleAllData"
          ],
          Warehouse: ["warehouses", "warehouse-details", "warehouse"],
          AdminNotifications: ["admin-notifications", "notifications"],
          ChatMessage: ["chat-messages", "chat-rooms", "chats"],
          ChatRoom: ["chat-rooms", "chats"],
          ProductManifest: ["unifiedManifest", "itemProductData", "itemProductViewData", "orders", "order-details", "order", "ordersData"],
          LinehaulManifest: ["unifiedManifest", "linehaulManifest", "linehaulManifestData", "linehaulShipments", "orders", "order-details", "order", "ordersData", "pickupLocationData"],
          ShippingPartnerManifest: ["unifiedManifest", "shipping-partner-manifest", "shipping-partner-manifest-details", "orders", "order-details", "order", "ordersData", "pickupLocationData", "linehaulShipments"],
          ReturnToShipper: ["unifiedManifest", "orders", "order-details", "order", "ordersData", "returnToShipper", "pickupLocationData"],
          DRS: ["DRSData", "DRSDetails", "CodOrdersTransactionsData", "orders", "ordersData", "swapData", "swapDetails", "pickupLocationData", "linehaulShipments", "pickupShipments", "returnToShipper", "shipping-partner-manifest-details", "itemProductViewData", "routeOrdersData"],
          OutForDeliveryOrder: ["DRSData", "DRSDetails", "CodOrdersTransactionsData", "orders", "ordersData", "swapData", "swapDetails", "pickupLocationData", "linehaulShipments", "pickupShipments", "returnToShipper", "shipping-partner-manifest-details", "itemProductViewData", "routeOrdersData"],
          DRSSwap: ["DRSData", "DRSDetails", "CodOrdersTransactionsData", "orders", "ordersData", "swapData", "swapDetails", "pickupLocationData", "linehaulShipments", "pickupShipments", "returnToShipper", "shipping-partner-manifest-details", "itemProductViewData", "routeOrdersData"],
          Inventory: ["shipmentInventoryList", "locationInventory", "orders", "order-details", "order", "ordersData"],
          InventoryMovement: ["shipmentInventoryList", "locationInventory", "orders", "order-details", "order", "ordersData"],
          ProductItem: ["itemCategoriesData", "productItemsViewData", "allListCategories", "itemSubCategoriesData", "orders", "order-details", "order", "ordersData"],
          ProductVariant: ["itemCategoriesData", "productItemsViewData", "allListCategories", "itemSubCategoriesData", "orders", "order-details", "order", "ordersData"],
          WhAreas: ["shelfList", "shelfAllData", "shelf", "shelfRowsAllData", "shelfRow", "shelfRowBayBins", "shelfRowBayBin", "shelfAreaFloors", "shelfRowFloors", "shelfRowFloor", "shelfRowPallets", "shelfRowPallet", "shelfRowWhRows", "shelfRowWhRow", "locationInventory"],
          WhRows: ["shelfList", "shelfAllData", "shelf", "shelfRowsAllData", "shelfRow", "shelfRowBayBins", "shelfRowBayBin", "shelfAreaFloors", "shelfRowFloors", "shelfRowFloor", "shelfRowPallets", "shelfRowPallet", "shelfRowWhRows", "shelfRowWhRow", "locationInventory"],
          WhRacks: ["shelfList", "shelfAllData", "shelf", "shelfRowsAllData", "shelfRow", "shelfRowBayBins", "shelfRowBayBin", "shelfAreaFloors", "shelfRowFloors", "shelfRowFloor", "shelfRowPallets", "shelfRowPallet", "shelfRowWhRows", "shelfRowWhRow", "locationInventory"],
          WhLevels: ["shelfList", "shelfAllData", "shelf", "shelfRowsAllData", "shelfRow", "shelfRowBayBins", "shelfRowBayBin", "shelfAreaFloors", "shelfRowFloors", "shelfRowFloor", "shelfRowPallets", "shelfRowPallet", "shelfRowWhRows", "shelfRowWhRow", "locationInventory"],
          WhBins: ["shelfList", "shelfAllData", "shelf", "shelfRowsAllData", "shelfRow", "shelfRowBayBins", "shelfRowBayBin", "shelfAreaFloors", "shelfRowFloors", "shelfRowFloor", "shelfRowPallets", "shelfRowPallet", "shelfRowWhRows", "shelfRowWhRow", "locationInventory"],
          WhFloors: ["shelfList", "shelfAllData", "shelf", "shelfRowsAllData", "shelfRow", "shelfRowBayBins", "shelfRowBayBin", "shelfAreaFloors", "shelfRowFloors", "shelfRowFloor", "shelfRowPallets", "shelfRowPallet", "shelfRowWhRows", "shelfRowWhRow", "locationInventory"],
          WhPallets: ["shelfList", "shelfAllData", "shelf", "shelfRowsAllData", "shelfRow", "shelfRowBayBins", "shelfRowBayBin", "shelfAreaFloors", "shelfRowFloors", "shelfRowFloor", "shelfRowPallets", "shelfRowPallet", "shelfRowWhRows", "shelfRowWhRow", "locationInventory"],
          ProductMovement: ["productItemsMovementData", "shipmentInventoryList", "locationInventory"],
          OrderAllocation: ["orderAllocationsData", "orders", "order-details", "order", "ordersData"],
          Outlet: ["outlets", "outletsData", "allOutlets", "singleOutlet"],
          Channel: ["integrationData", "salesIntegrationData", "salesChannelData", "channelData", "channelDetails", "integrationChannelsAll"],
          ChannelConnection: ["integrationData", "salesIntegrationData", "salesChannelData", "channelData", "channelDetails", "integrationChannelsAll", "aramexCredentials", "naqelCredentials", "zidCredentials", "jtCredentials"],
          ChannelCredential: ["integrationData", "salesIntegrationData", "salesChannelData", "channelData", "channelDetails", "integrationChannelsAll", "aramexCredentials", "naqelCredentials", "zidCredentials", "jtCredentials"],
          ChannelStatus: ["integrationData", "salesIntegrationData", "salesChannelData", "channelData", "channelDetails", "integrationChannelsAll"],
          Route: ["routesData", "warehouseRoutesData", "RouteDetails"],
          ZoneManagement: ["zoneManagementData", "shippingPartnersData"],
          Tire: ["tireData"],
          DarkStoreRadius: ["darkStoreRadiusData", "radiusAllData", "darkStoreAllData", "darkStoreDetailsData", "clientDarkStores", "darkStoreBranches"],
          DarkStoreRadiusPricing: ["darkStoreRadiusData", "radiusAllData", "darkStoreAllData", "darkStoreDetailsData", "clientDarkStores", "darkStoreBranches"],
          LmNotifications: ["NotificationsData", "AdminNotificationsData", "notificationDetails", "bulkJobNotificationDetails"],
          ShipmentMessageTemplate: ["shipmentnotification", "shipmentnotificationbyid"],
        };

        const keysToInvalidate = modelToQueryKey[data.model];
        if (keysToInvalidate) {
          keysToInvalidate.forEach((key) => {
            queryClient.invalidateQueries({ queryKey: [key] });
          });
        }
      });

      socket.on("user-login", (data: { id: string }) => {
        console.log("👤 User logged in:", data);
        const activeElement = document.activeElement;
        const isTyping = activeElement && ["INPUT", "TEXTAREA", "SELECT"].includes(activeElement.tagName);
        
        const hasActiveForm = Array.from(document.querySelectorAll("input, textarea, select")).some(el => {
          const tagName = el.tagName;
          const type = el.getAttribute("type");
          const placeholder = el.getAttribute("placeholder")?.toLowerCase() || "";
          const id = el.id?.toLowerCase() || "";
          const name = el.getAttribute("name")?.toLowerCase() || "";
          const className = el.className?.toLowerCase() || "";

          // Ignore checkboxes, radio buttons, hidden inputs, files, buttons
          const isIgnoredInput = type && ["checkbox", "radio", "hidden", "file", "button", "submit", "reset"].includes(type);
          if (isIgnoredInput) return false;

          // Ignore search fields
          const isSearch = type === "search" || 
                           placeholder.includes("search") || 
                           id.includes("search") || 
                           name.includes("search") || 
                           className.includes("search");
          if (isSearch) return false;

          // Ignore pagination selects / limit selectors
          const isPagination = tagName === "SELECT" && (
            name.includes("limit") || 
            name.includes("page") || 
            name.includes("size") || 
            id.includes("limit") || 
            id.includes("page") || 
            id.includes("size") || 
            className.includes("limit") || 
            className.includes("page") || 
            className.includes("size")
          );
          if (isPagination) return false;

          // Ignore filter & sort selectors
          const isFilterOrSort = name.includes("filter") || 
                                 name.includes("sort") || 
                                 id.includes("filter") || 
                                 id.includes("sort") || 
                                 className.includes("filter") || 
                                 className.includes("sort") || 
                                 placeholder.includes("filter") || 
                                 placeholder.includes("sort");
          if (isFilterOrSort) return false;

          // Ignore disabled / readonly
          const isDisabled = el.hasAttribute("disabled") || el.hasAttribute("readonly");
          if (isDisabled) return false;

          // Check if it is inside a form or a modal/sidebar/drawer/popup/overlay container
          let parent = el.parentElement;
          let insideFormOrModal = false;
          while (parent) {
            const pTagName = parent.tagName;
            const pRole = parent.getAttribute("role") || "";
            const pId = parent.id || "";
            const pClassName = typeof parent.className === "string" ? parent.className : "";

            if (pTagName === "FORM" || pTagName === "DIALOG") {
              insideFormOrModal = true;
              break;
            }
            if (pRole === "dialog" || pRole === "alertdialog") {
              insideFormOrModal = true;
              break;
            }
            const lowerId = pId.toLowerCase();
            const lowerClass = pClassName.toLowerCase();
            if (
              lowerId.includes("modal") || lowerId.includes("dialog") || lowerId.includes("drawer") || lowerId.includes("sidebar") || lowerId.includes("popup") ||
              lowerClass.includes("modal") || lowerClass.includes("dialog") || lowerClass.includes("drawer") || lowerClass.includes("sidebar") || lowerClass.includes("popup") ||
              (lowerClass.includes("fixed") && lowerClass.includes("z-"))
            ) {
              insideFormOrModal = true;
              break;
            }
            parent = parent.parentElement;
          }

          if (!insideFormOrModal) return false;

          // If we reach here, it's an active text/number/email/select/textarea form field inside a form/modal
          return true;
        });

        const isEditingPath = /[\/(]edit|install|connect|add|create|fill-info/i.test(window.location.pathname);
        if (isTyping || hasActiveForm || isEditingPath) {
          return;
        }
        if (data.id !== user?.id) {
          queryClient.invalidateQueries();
        }
      });

      return () => {
        socket.off("connect");
        socket.off("disconnect");
        socket.off("location received");
        socket.off("notification Received");
        socket.off("chat-notification");
        socket.off("ticket-notification");
        socket.off("new-order-status");
        socket.off("pickup-assign-driver");
        socket.off("linehaul-status-update");
        socket.off("return-to-shipper-status-update");
        socket.off("staff-update");
        socket.off("driver-update");
        socket.off("out-source-update");
        socket.off("client-update");
        socket.off("driver-location-update");
        socket.off("drivers-batch-update");
        socket.off("initial-driver-data");
        socket.off("driver-status-change");
        socket.off("backend-change");
        socket.off("user-login");
      };
    }
  }, [user?.id]);

  // Emit new notifications
  useEffect(() => {
    if (user && socketRef.current) {
      socketRef.current.emit("New Notification", user);
    }
  }, [user, socketRef.current]);

  if (!isSuccess || data === undefined) {
    return <LoadingScreen />;
  }

  return (
    <div className="bg-gradient-to-tl from-20% to-[#E4E5E7] from-[#F9ECB7] h-screen overflow-hidden overflow-y-auto">
      {!hideHeader && <Header />}
      <GlobalTooltipPortal />
      <Toaster
        containerStyle={{
          zIndex: 99999,
        }}
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: "8px",
            background: "#333",
            color: "#fff",
          },
          success: {
            style: {
              background: "#FBD037",
              color: "#212121",
            },
          },
          error: {
            style: {
              background: "#FF4D4F",
              color: "#fff",
            },
          },
        }}
      />

      <Routes>
        {data && isSuccess && data !== "Invalid or expired token" ? (
          <>
            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
            <Route path="/orders" element={<OrderManagement />} />
            <Route path="/orders/:awb" element={<ViewOrderDetails />} />
            <Route path="/staff/:id" element={<ViewStaffDetails />} />
            <Route
              path="/view-merchant-details/:id"
              element={<ViewMerchantDetails />}
            />
            <Route path="/driver/:id" element={<ViewDriverDetails />} />
            <Route path="/dark-store" element={<DarkStoreManagement />} />
            <Route path="/dark-store/:id" element={<ViewDarkStoreDetails />} />
            <Route
              path="/view-outsource-details/:id"
              element={<ViewOutSourceDetails />}
            />
            <Route
              path="/view-customer-details/:id"
              element={<ViewCustomerDetails />}
            />
            <Route path="/route-assign/:id" element={<RouteAssign />} />
            <Route path="/route-add" element={<AddRoute />} />
            <Route
              path="/view-vehicle-details/:id"
              element={<ViewVehicleDetails />}
            />
            <Route path="/pending-order/:id" element={<PendingOrders />} />
            <Route
              path="/shopify-pending-order/:id"
              element={<ShopifyPendingOrders />}
            />
            <Route path="/manifest-details/:id" element={<ManifestDetails />} />
            <Route
              path="/linehaul-details/:id"
              element={<LinehaulViewDetails />}
            />
            <Route
              path="/return-to-shipper/:id"
              element={<ReturnToShiperViewDetails />}
            />
            <Route
              path="/shipping-menifest-detail/:id"
              element={<ShippingManifiestViewDetail />}
            />
            <Route
              path="/view-coverage-cities-details/:id"
              element={<ViewCoverageCitiesDetails />}
            />
            <Route
              path="/view-district-details/:id"
              element={<ViewDistrictDetails />}
            />
            <Route path="/notification-view" element={<NotificationView />} />
            <Route path="/shipment-list/:drsId" element={<ShipmentList />} />
            <Route path="/help-and-support" element={<HelpandSupport />} />
            <Route path="/location" element={<Location />} />
            <Route path="/users" element={<Users />} />
            <Route path="/integration" element={<Integration />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/odometer" element={<Odometer />} />
            <Route path="/fuel" element={<Fuel />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/integration/:id" element={<HowInstall />} />
            <Route
              path="/integration/:id/install"
              element={<FillInstallationDetails />}
            />
            <Route
              path="/integration/:id/connect/:insalledId"
              element={<KeyedEditModal />}
            />
            {/* <Route
              path="/integration/:id/connect"
              element={<CredentialsModal />}
            /> */}
            <Route path="/forward" element={<Forward />} />
            <Route path="/search-results" element={<SearchResults />} />
            <Route path="/inventory-product" element={<InverntoryProduct />} />
            <Route path="/inventory-shelve" element={<ShelveManagement />} />
            <Route
              path="/inventory-management"
              element={<InventoryMangement />}
            />
            <Route path="/add-item" element={<AddItem />} />
            <Route path="/add-item/:id" element={<AddItem />} />
            <Route path="/outlet-management" element={<OutletManagement />} />
            <Route path="/zone-management" element={<ZoneManagement />} />
            <Route path="/pickup-management" element={<PickupManagement />} />
            <Route path="/invoice-management" element={<InvoiceManagement />} />
            <Route path="/documents" element={<DocumentDesigner />} />
            <Route
              path="/manifest-management"
              element={<ManifestManagement />}
            />
            <Route path="/fleet-management" element={<FleetManagement />} />
            <Route path="/drs-management" element={<DRSManagement />} />
            <Route path="/reports" element={<ProductItemsMovement />} />
            <Route path="/route-management" element={<RouteManagement />} />
            <Route path="/weight-management" element={<WeightManagement />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/activity-logs" element={<ActivityLogs />} />
            <Route
              path="/shipping-configuration"
              element={<ShippingConfiguration />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/warehouse" element={<Warehouse />} />
            <Route
              path="/line-haul-management"
              element={<LineHaulManagement />}
            />
            <Route path="/create-warehouse" element={<CreateWarehouse />} />
            <Route path="/created-orders" element={<CreatedOrders />} />
            <Route path="/pick-list" element={<PickListPage />} />
            <Route path="/packaging" element={<Packaging />} />
            <Route path="/create-order" element={<CreateOrder />} />
            <Route path="/dispatched" element={<Dispatched />} />
             {hasHRMSAccess ? (
               <>
                  <Route path="/company" element={<CompanyPage />} />
                  <Route path="/hr" element={<HRPage />} />
                  <Route path="/hr/employee/:id" element={<EmployeeDetails />} />
                  <Route path="/hr-settings" element={<HRSetting />} />
                 <Route path="/recruitment" element={<RecruitmentPage />} />
                 <Route path="/payroll" element={<PayrollPage />} />
                 <Route path="/letter" element={<LetterPage />} />
                 <Route path="/noticeboard" element={<NoticeboardPage />} />
                 <Route path="/asset" element={<AssetPage />} />
                 <Route path="/performance" element={<PerformancePage />} />
               </>
             ) : (
               <>
                  <Route path="/company" element={<Navigate to="/orders" replace />} />
                  <Route path="/hr" element={<Navigate to="/orders" replace />} />
                  <Route path="/hr/employee/:id" element={<Navigate to="/orders" replace />} />
                  <Route path="/hr-settings" element={<Navigate to="/orders" replace />} />
                 <Route path="/recruitment" element={<Navigate to="/orders" replace />} />
                 <Route path="/payroll" element={<Navigate to="/orders" replace />} />
                 <Route path="/letter" element={<Navigate to="/orders" replace />} />
                 <Route path="/noticeboard" element={<Navigate to="/orders" replace />} />
                 <Route path="/asset" element={<Navigate to="/orders" replace />} />
                 <Route path="/performance" element={<Navigate to="/orders" replace />} />
               </>
             )}
          </>
        ) : (
          <>
            <Route path="/fill-info" element={<FillInformation />} />
            <Route path="/" element={<LoginComponent />} />
            <Route path="/forgot-password" element={<ForgotComponent />} />
            <Route
              path="/password-changed"
              element={<ChangePasswordComponent />}
            />
          </>
        )}
      </Routes>

      {/* Floating Chat Support */}
      {!hideHeader && <FloatingChatButton />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
